@if (modalService.isActive()) {
	<div class="m-modal-container">
		<a-overlay class="m-modal-container__overlay" (clicked)="overlayClicked()"></a-overlay>
		<div class="m-modal-container__content">
			<ng-container *ngTemplateOutlet="modalService.getActiveModal().template"></ng-container>
		</div>
	</div>
}
